import { SupportTokenAction } from '@apeiron/config'
import { useCurrencyContext } from '@apeiron/currency'
import { IconText } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { useDailyCheckInContext } from '@src/contexts/reward/DailyCheckInContext'
import { FC, useMemo } from 'react'

const Container = styled(Box)`
  background-color: #00000033;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 3px 10px;
  width: 250px;
`

const StyledIconText = styled(IconText)`
  .Custom-Text {
    color: #f1b535;
    font-size: 20px;
    font-weight: 300;
  }
  .Custom-Icon {
    width: 32px;
  }
`

const CheckInStardust: FC<Props> = (props: Props) => {
  const { className } = props

  const { displayStardust } = useDailyCheckInContext()

  const { getDefaultSupportCurrency } = useCurrencyContext()

  const currency = useMemo(
    () => getDefaultSupportCurrency(SupportTokenAction.DailyCheckIn),
    [getDefaultSupportCurrency]
  )

  return (
    <Container className={className}>
      <StyledIconText startSrc={currency?.image} text={displayStardust} />
    </Container>
  )
}

type Props = {
  className?: string
}

export default CheckInStardust
